// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ax5Q","colBig":"styles_colBig__2THFI","colSmall":"styles_colSmall__8R986"};